import React from 'react';
import { Form } from 'semantic-ui-react';
import { TimeInput } from 'semantic-ui-calendar-react';


const WorkshopForm = (props) => {
  
  const { beginTime, endTime, organizer, participantLimit } = props.data;
  const { onChange } = props;

  return (
    <div>
      <Form.Group widths='equal'>
        <TimeInput
          required
          name="beginTime"
          label="Begin"
          placeholder="Workshop begin time"
          value={beginTime}
          iconPosition="left"
          onChange={onChange} />
        <TimeInput
          required
          name="endTime"
          label="End"
          placeholder="Workshop end time"
          value={endTime}
          iconPosition="left"
          onChange={onChange} />
        <Form.Input
          required
          label='Participant limit'
          placeholder='Enter upper threshold for participants'
          name='participantLimit'
          value={participantLimit}
          onChange={onChange} />
      </Form.Group>
      <Form.Group widths='equal'>
        <Form.Input
          required
          label='Organizer'
          placeholder='Organizer'
          name='organizer'
          value={organizer}
          onChange={onChange} />
      </Form.Group>
    </div>
  );
};

export default WorkshopForm;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/Workshop.js